import { Modal } from "@components/Modal";
import { useTranslation } from "@helpers/useTranslation";
import { FC } from "react";
import { WheelEntry } from "./Wheel";

type Props = {
  winner: WheelEntry;
  onKeep: () => void;
  onRemove: () => void;
};

export const WinnerModal: FC<Props> = ({ winner, onKeep, onRemove }) => {
  const { t } = useTranslation("admin");

  return (
    <Modal show={true} onCancel={onKeep} size="md" hideX>
      <div className="flex flex-col items-center px-4 py-6 text-center">
        <h2 className="mb-6 text-2xl font-bold">{t("congratulations")}</h2>
        <p className="text-sm text-gray-500">{t("theWinnerIs")}</p>
        <div className="my-6 break-words text-4xl font-extrabold text-primary">
          {winner.label}
          {winner.subtitle && <div className="mt-2 text-lg font-normal text-gray-500">{winner.subtitle}</div>}
        </div>
        <div className="mt-4 flex w-full flex-col gap-3 sm:flex-row sm:justify-center">
          <button onClick={onKeep} className="btn-outline btn">
            {t("keepInList")}
          </button>
          <button onClick={onRemove} className="btn-error btn text-white">
            {t("removeFromList")}
          </button>
        </div>
      </div>
    </Modal>
  );
};
